import SalesOffice from './SalesOffice'
export class DriverInfo {
    RequestID: number;
    DriverName: string;
    DriverPersonnelNumber: string;
    CrossDockSalesOfficeID: number;
    CrossDockSalesOffice: SalesOffice;
    SalesRoute: string;
}

export default DriverInfo;